import React from "react";
import { Grid, Card, CardContent, Typography, Container } from "@mui/material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";

// Section with white background
const Section = styled("section")({
  background: "#ffffff",
  padding: "120px 0",
  textAlign: "center",
  overflowX: "auto",
});

// Card styling
const ServiceCard = styled(Card)(() => ({
  backgroundColor: "#D9D9D9",
  height: "250px",
  width: "310px",
  textAlign: "center",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  transition: "box-shadow 0.3s ease, background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "#4484CE",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
}));

const features = [
  {
    title: "UI/UX Design",
    description: "Creating visually appealing and user-friendly interfaces.",
    icon: <DesignServicesIcon sx={{ fontSize: 50, color: "#3498db" }} />,
    link: "/ui-ux-design",
  },
  {
    title: "Web Development",
    description: "Building scalable and responsive websites.",
    icon: <CodeIcon sx={{ fontSize: 50, color: "#2ecc71" }} />,
    link: "/web-development",
  },
  {
    title: "Database Management",
    description: "Optimized storage and retrieval solutions.",
    icon: <StorageIcon sx={{ fontSize: 50, color: "#e74c3c" }} />,
    link: "/database-management",
  },
  {
    title: "Marketing",
    description: "Strategies to enhance your online presence.",
    icon: <StorageIcon sx={{ fontSize: 50, color: "#e74c3c" }} />,
    link: "/marketing",
  },
];

const Features = () => {
  const navigate = useNavigate();

  return (
    <Section>
      <Typography variant="h2" sx={{ fontWeight: "bold", color: "black", marginBottom: "30px" }}>
        Our Services
      </Typography>

      <Container>
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
        >
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <ServiceCard onClick={() => navigate(feature.link)}>
                <CardContent>
                  {feature.icon}
                  <Typography variant="h4" sx={{ marginTop: "10px", fontWeight: "bold" }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ marginTop: "15px", color: "#555", fontSize: "1.1rem" }}>
                    {feature.description}
                  </Typography>
                </CardContent>
              </ServiceCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default Features;
